// discover-template.js
(function () {
  "use strict";

  function init() {
    /* ---- Scroll Reveal ---- */
    var reveals = document.querySelectorAll(".df-reveal");
    if (reveals.length) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("df-revealed");
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
      );

      reveals.forEach(function (el) {
        revealObserver.observe(el);
      });
    }

    /* ---- Sticky Sub-Nav ---- */
    var subnav = document.getElementById("dfSubnav");
    var hero = document.getElementById("df-hero");

    if (subnav && hero) {
      function updateSubnav() {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var heroBottom = hero.offsetTop + hero.offsetHeight;

        if (scrollY > heroBottom) {
          subnav.classList.add("df-subnav--visible");
          subnav.setAttribute("aria-hidden", "false");
        } else {
          subnav.classList.remove("df-subnav--visible");
          subnav.setAttribute("aria-hidden", "true");
        }

        /* Active section highlighting */
        var links = subnav.querySelectorAll('.df-subnav__link[href^="#"]');
        var fromTop = scrollY + 80;

        links.forEach(function (link) {
          var id = link.getAttribute("href");
          if (id === "#") return;

          var section = document.querySelector(id);
          if (!section) return;

          var active =
            section.offsetTop <= fromTop &&
            section.offsetTop + section.offsetHeight > fromTop;

          link.classList.toggle("df-subnav__link--active", active);
        });
      }

      window.addEventListener("scroll", updateSubnav, { passive: true });
      updateSubnav();
    }

    /* ---- Carousel ---- */
    var track = document.getElementById("dfCarouselTrack");
    var prevBtn = document.getElementById("dfCarouselPrev");
    var nextBtn = document.getElementById("dfCarouselNext");
    var carouselIndex = 0;

    function getVisibleCount() {
      if (window.innerWidth < 600) return 1.2;
      if (window.innerWidth < 900) return 2.2;
      return 3.5;
    }

    function moveCarousel(dir) {
      if (!track) return;

      var slides = track.querySelectorAll(".df-carousel__slide");
      if (!slides.length) return;

      var visible = getVisibleCount();
      var maxIndex = Math.max(0, slides.length - Math.floor(visible));

      carouselIndex = Math.min(Math.max(carouselIndex + dir, 0), maxIndex);

      var pct = -(carouselIndex * (100 / Math.floor(visible)));
      track.style.transform = "translateX(" + pct + "%)";
    }

    if (track && prevBtn && nextBtn) {
      prevBtn.addEventListener("click", function () {
        moveCarousel(-1);
      });
      nextBtn.addEventListener("click", function () {
        moveCarousel(1);
      });
    }

    /* ---- Build Selector ---- */
    var swatchContainer = document.getElementById("dfSwatches");
    var buildNameEl = document.getElementById("dfBuildName");
    var buildCta = document.getElementById("dfBuildCta");
    var buildImages = document.querySelectorAll(".df-build__bike");

    if (swatchContainer && buildNameEl && buildCta) {
      swatchContainer.addEventListener("click", function (e) {
        var btn = e.target.closest(".df-build__swatch");
        if (!btn) return;

        var build = btn.dataset.build;
        var url = btn.dataset.url;

        buildNameEl.textContent = build || "";
        if (url) buildCta.href = url;

        /* Update active class and aria-pressed */
        swatchContainer
          .querySelectorAll(".df-build__swatch")
          .forEach(function (s) {
            s.classList.remove("df-build__swatch--active");
            s.setAttribute("aria-pressed", "false");
          });

        btn.classList.add("df-build__swatch--active");
        btn.setAttribute("aria-pressed", "true");

        buildImages.forEach(function (img) {
          img.classList.toggle(
            "df-build__bike--active",
            img.dataset.build === build
          );
        });
      });
    }

    /* ---- Feature Showcase Tabs ---- */
    var showcaseTabs = document.querySelectorAll(".df-showcase__tab");
    var showcaseImages = document.querySelectorAll(".df-showcase__image");
    var showcaseDescs = document.querySelectorAll(".df-showcase__desc-text");

    if (showcaseTabs.length) {
      showcaseTabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          var feature = this.dataset.feature;

          // Update active tab and aria-selected
          showcaseTabs.forEach(function (t) {
            t.classList.remove("df-showcase__tab--active");
            t.setAttribute("aria-selected", "false");
          });
          this.classList.add("df-showcase__tab--active");
          this.setAttribute("aria-selected", "true");

          // Swap image
          showcaseImages.forEach(function (img) {
            img.classList.toggle(
              "df-showcase__image--active",
              img.dataset.feature === feature
            );
          });

          // Swap description
          showcaseDescs.forEach(function (desc) {
            desc.classList.toggle(
              "df-showcase__desc-text--active",
              desc.dataset.feature === feature
            );
          });
        });
      });
    }

    /* ---- Smooth scroll for nav links ---- */
    document
      .querySelectorAll('.df-subnav__link[href^="#"]')
      .forEach(function (link) {
        link.addEventListener("click", function (e) {
          var href = this.getAttribute("href");
          if (!href || href === "#") return;

          var target = document.querySelector(href);
          if (!target) return;

          e.preventDefault();

          var offset = 60;
          var top =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            offset;

          window.scrollTo({ top: top, behavior: "smooth" });
        });
      });
  }

  // If loaded with `defer`, DOM is already parsed and this runs immediately.
  // If not, this keeps it safe.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();